import { type BlokProps, StoryblokComponent } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import { ProductCard } from "~/features/products/ProductCard/ProductCard";
import type { BundleStoryblok } from "~/generated/sb/blok-types";
import { sizes } from "~/lib/utils/sizes";
import type { BlokData } from "~/srpc/routes/story.router";
import styles from "./BundleBlok.module.css";

export const BundleBlok = ({
	blok,
	data,
	preview,
}: BlokProps<BundleStoryblok, BlokData["bundle"]>) => {
	return (
		<BlokWrap
			as="div"
			editable={blok}
			className={styles.root}
			data-layout="blok"
			data-mobile-bleed="true"
		>
			<div className={styles.title__wrapper}>
				<div className={styles.overtitle__wrapper}>
					{blok.sku && <span>{blok.sku}</span>}
					{blok.category && <span className={styles.category}>{blok.category}</span>}
				</div>
				{blok.title && <h2 className={clsx("blok-big-title", styles.title)}>{blok.title}</h2>}
				{blok.subtitle && (
					<h3 className={clsx("blok-subtitle", styles.subtitle)}>{blok.subtitle}</h3>
				)}
			</div>

			<div className={styles.main__grid}>
				<div className={styles.left}>
					<div className={styles.left__inner}>
						<StoryblokComponent blok={blok?.Media?.[0]} sizes={sizes(80, 50)} preview={preview} />
					</div>
				</div>
				<div className={styles.right}>
					{data?.map((product) => (
						<ProductCard productCard={product} key={product?.name} />
					))}
				</div>
			</div>
		</BlokWrap>
	);
};
